exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".condition-col{background:#fff;padding:10px;box-shadow:0 0 10px rgba(0,0,0,0.15);display:inline-block;border-radius:4px;vertical-align:middle;position:relative;transition:0.2s linear;cursor:pointer}.condition-col:hover{box-shadow:0 0 15px 3px rgba(0,0,0,0.15)}.condition-col:hover .btn-close{opacity:1;visibility:visible}.condition-col+.condition-col{margin-left:110px}.condition-col+.condition-col:before{content:'';position:absolute;top:50%;transform:translateY(-50%);left:-109px;width:109px;height:1px;background:#CC1A97}.condition-col .label{margin:3px 2px;display:inline-block;font-weight:400;padding:4px 6px}.cnod-toggle{position:absolute;color:#fff;background:#CC1A97;padding:3px 12px;border-radius:20px;bottom:-54px;left:27px;z-index:11;min-width:72px;white-space:nowrap}.cnod-toggle:after{content:'';display:inline-block;right:8px;top:3px;position:absolute;margin-left:7px;margin-top:3px;font:normal normal normal 14px/1 FontAwesome;content:'\\F0DC'}.cnod-toggle:hover{cursor:pointer}.cnod-toggle.or{background:#673bb7}.condition-wrapper{width:calc(100vw - 130px);padding:20px}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/new-rule/condition-row/condition-row.component.scss
// module id = 1363
// module chunks = 1